// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedSwitch_container__3NULp"};